import React, { useState } from 'react';
import './App.css';

import Header from './components/Header'
import Create from './pages/Create'
import CreateSequence from './pages/CreateSequence'
import Home from './pages/Home'
import Sequence from './pages/Sequence';
import Article from './pages/Article';
import Login from './pages/Login';
import Profile from './pages/Profile'
import Edit from './pages/Edit'
import fire, { FirebaseContext } from './firebase'
import useAuth from './auth/useAuth'

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

function App() {

  const [activeArticle, setActiveArticle] = useState("")
  const user = useAuth()

  function logout() {
    fire.auth().signOut()
  }

  return (
    <Router>
      <FirebaseContext.Provider value={{ user, fire }}>
        <Header logout={logout} />
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>

          <Route exact path="/create">
            <Create />
          </Route>

          <Route path="/create/sequence">
            <CreateSequence />
          </Route>

          <Route path="/edit/:sequenceId">
            <Edit />
          </Route>

          <Route path="/profile">
            <Profile />
          </Route>

          <Route path="/login">
            <Login />
          </Route>

          <Route exact path="/sequence/:sequenceId">
            <Sequence
              setArticle={setActiveArticle}
              article={activeArticle} />
          </Route>

          <Route path="/sequence/:sequenceId/:articleId">
            <Article
              // setArticle={setActiveArticle}
              article={activeArticle} />
          </Route>
        </Switch>
      </FirebaseContext.Provider>
    </Router>
  )
}

export default App;
